import React from 'react'
import LinkItem from './LinkItem.jsx'
import PropTypes from 'prop-types'
import { push } from 'Helper/routeHelpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useUIConfig } from 'hooks/useURL'

const AdminDisplayScreenSubmenu = ({ disabled }) => {
  const { screens: adminDisplayScreens = [] } = useUIConfig('adminDisplay')

  const dashboardClick = (e, path = '') => {
    e.preventDefault()
    push('dashboard/admin' + path)
  }

  if (
    adminDisplayScreens == null ||
    adminDisplayScreens.length === 0
  ) {
    return (
      <li className={disabled === true ? 'disabled' : ''}>
        <a
          role="button"
          aria-label="admin dashboard screen"
          onClick={
            disabled === true
              ? () => null
              : e => dashboardClick(e)
          }
        >
          <FontAwesomeIcon icon={['far', 'toolbox']} />
          System Management
        </a>
      </li>
    )
  } else if (adminDisplayScreens.length === 1) {
    return (
      <li className={disabled === true ? 'disabled' : ''}>
        <a
          role="button"
          aria-label="admin dashboard screen"
          onClick={
            disabled === true
              ? () => null
              : e =>
                dashboardClick(
                  e,
                  '/screen/' + adminDisplayScreens[0].path
                )
          }
        >
          <FontAwesomeIcon icon={['far', 'toolbox']} />
          System Management
        </a>
      </li>
    )
  } else {
    const adminDisplayScreenList = [...adminDisplayScreens].sort(
      (a, b) => {
        const textA = a.name ? a.name.toUpperCase() : ''
        const textB = b.name ? b.name.toUpperCase() : ''
        return textA < textB ? -1 : textA > textB ? 1 : 0
      }
    )
    return (
      <li
        className={
          disabled === true
            ? 'dropdown-submenu disabled'
            : 'dropdown-submenu'
        }
      >
        <a
          className="dropdown-toggle"
          id="screensDropDown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          role="button"
          aria-labelledby="dashboard screen"
          onClick={
            disabled === true ? () => null : dashboardClick
          }
        >
          <FontAwesomeIcon icon={['far', 'toolbox']} />
          System Management
        </a>
        {disabled
          ? null
          : (
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="screens menu"
          >
            {adminDisplayScreenList.map((screen, idx) => {
              return (
                <LinkItem
                  key={idx}
                  item={screen}
                  type="screen"
                  prefix="/admin"
                  context="adminDisplay"
                />
              )
            })}
          </ul>
            )}
      </li>
    )
  }
}

AdminDisplayScreenSubmenu.propTypes = {
  // Should the dashboard menu be enabled or not
  disabled: PropTypes.bool
}

export default AdminDisplayScreenSubmenu
